import { cn } from "@/shared/lib/utils";

import { scorePassword, type PasswordStrengthLevel } from "../utils/passwordStrength";

interface PasswordStrengthMeterProps {
  value: string;
  /** Localized labels per level: [empty, weak, fair, good, strong] */
  labels: readonly [string, string, string, string, string];
  /** Aria-label for the bar group */
  ariaLabel?: string;
}

const BAR_COLOR: Record<PasswordStrengthLevel, string> = {
  0: "bg-zinc-200 dark:bg-zinc-700",
  1: "bg-red-500",
  2: "bg-orange-500",
  3: "bg-yellow-500",
  4: "bg-green-500",
};

export function PasswordStrengthMeter({ value, labels, ariaLabel }: PasswordStrengthMeterProps) {
  const { score } = scorePassword(value);
  const label = labels[score];

  return (
    <div role="status" aria-live="polite" aria-label={ariaLabel} className="flex flex-col gap-1">
      <div className="flex gap-1" aria-hidden>
        {[1, 2, 3, 4].map((step) => (
          <div
            key={step}
            className={cn(
              "h-1 flex-1 rounded-full transition-colors",
              step <= score ? BAR_COLOR[score] : "bg-zinc-200 dark:bg-zinc-700",
            )}
          />
        ))}
      </div>
      <span className="text-xs text-zinc-600 dark:text-zinc-400">{label}</span>
    </div>
  );
}
